<div class="payments-button-wrapper">
  <button type="button" class="cta">
    {{ buttonCta }}
  </button>

  <div
    *ngIf="hasBankTransfer || hasCardPayments || hasPaypalEc"
    class="payment-logos"
  >
    <app-icon *ngIf="hasPaypalEc" class="paypal-icon" [icon]="paypalIcon">
    </app-icon>

    <app-credit-cards
      *ngIf="hasCardPayments"
      [cards]="paymentsSettings.availableCardTypes"
    >
    </app-credit-cards>

    <app-icon
      *ngIf="hasBankTransfer"
      class="bank-transfer-icon"
      [icon]="bankTransferIcon"
    >
    </app-icon>
  </div>
</div>

<div
  *ngIf="paymentNotificationsText"
  class="payment-note"
  [innerHTML]="paymentNotificationsText"
></div>
